var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcdonald(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4666 13.796C27.1722 13.7364 28.7827 20.8846 29.0935 29.7858L31.572 29.6993C31.2379 20.1318 28.4619 12.464 25.3971 12.571C23.6382 12.6324 22.1734 15.005 21.2882 18.6915C20.148 15.0757 18.5213 12.8111 16.789 12.8716C13.7242 12.9786 11.5166 20.8205 11.8507 30.388L14.3292 30.3014C14.0183 21.4002 15.1262 14.1571 16.8319 14.0975C18.5375 14.038 20.1293 20.6531 20.415 28.8348L22.8669 28.7492C22.6078 20.5666 23.7343 13.8565 25.4666 13.796Z",
    fill: "#FFD200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcdonald);
export default __webpack_public_path__ + "static/media/mcdonald.150b2e4ee261e62d6d98ece7bb482b5a.svg";
export { ForwardRef as ReactComponent };